import { supportsInterface } from '../datasource/Erc165DataSource'

const _INTERFACE_ID_ERC721 = '0x80ac58cd'

export const getIsContractErc721 = async (web3, contractAddress) => {
  return supportsInterface(web3, contractAddress, _INTERFACE_ID_ERC721)
}
